






































import Vue from 'vue';
import {RoutsData} from '../router/routs';
import {ChannelApi} from '../api/channel-api';
import {Channel} from '../types/channel';

export default Vue.extend({
  name: 'ChannelList',
  beforeMount() {
    this.getData();
  },
  data() {
    return {
      channels: [] as Channel[],
      load: false,
      addChannel: {name: RoutsData.CHANNEL_ADD.name}
    };
  },
  methods: {
    async getData() {
      this.load = true;
      ChannelApi.getList().then(res => this.channels = res.data).finally(() => this.load = false);
    }
  }
});
